import React, { useState, useEffect, useRef,useContext } from 'react';
import Context from '../../../context/Context';
import { Input, Table,  message,Pagination } from 'antd';
import { debounce } from 'lodash';
import { IoSearchOutline } from 'react-icons/io5';
import moment from 'moment';

import { api } from '../../../api/api';
import SuccessIcon from '../../../assets/successicon.svg';

import styles from './completedDeactivation.module.scss';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
const getFacilityNamesFromCodes = (codesStr, facilities = []) => {
  if (!codesStr) return '';

  const codes = String(codesStr)
	.split(',')
	.map((c) => c.trim())
	.filter(Boolean);

  const map = new Map(
	(facilities || []).map((f) => [String(f.facility).trim(), f.facilityName])
  );

  return codes.map((code) => map.get(code) || code).join(', ');
};
const CompletedDeactivation = () => {
	const userDetails = JSON.parse(localStorage.getItem('user-onboard-data'));
	const isAdmin = userDetails?.isAdmin === 'Y';
	const { SSPFacilities } = useContext(Context);

	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [searchText, setSearchText] = useState('');
	const [tableParams, setTableParams] = useState({
		pagination: {
			current: 1,
			pageSize: 10,
			showSizeChanger: true,
			showQuickJumper: true,
			total: 0,
			// showTotal: (total) => `Total ${total} items`,
		},
	});
const [visibleNric, setVisibleNric] = useState({});
	const toggleNric = (id) => {
		setVisibleNric((prev) => {
			const isNowVisible = !prev[id];

			if (isNowVisible) {
				setTimeout(() => {
					setVisibleNric((p) => ({
						...p,
						[id]: false,
					}));
				}, 10000);
			}

			return {
				...prev,
				[id]: isNowVisible,
			};
		});
	};
	// Fetch the data from API
	const fetchUserPendingList = async () => {
		setLoading(true);
		try {
			const { current, pageSize } = tableParams.pagination;
			const response = await api.get({
				path:
					userDetails?.isAdmin === 'Y'
						? `/getAdminAllDeactivateCompletedList`
						: `/getUserAllDeactivateCompletedList?nhName=${userDetails?.nhName}`,
				params: { page: current, size: pageSize, searchText },
				service: 'useronboarding',
			});

			if (response.status === 200) {
				const pendinglist = response.data?.data;
				const totaldata = response.data?.pagination?.totalData;

				setData(pendinglist);

				setTableParams((prev) => ({
					...prev,
					pagination: {
						...prev.pagination,
						total: totaldata || response.data?.data?.length,
					},
				}));
			}
		} catch (error) {
			message.error('Something went wrong!');
		} finally {
			setLoading(false);
		}
	};

	const handleTableChange = (pagination) => {
		setTableParams((prev) => ({
			...prev,
			pagination,
		}));
	};

	const handleSearch = (e) => {
		const value = e.target.value;
		setSearchText(value.length >= 3 ? value : '');
		setTableParams((prev) => ({
			...prev,
			pagination: { ...prev.pagination, current: 1 },
		}));
		}

	useEffect(() => {
		fetchUserPendingList(); //eslint-disable-next-line
	}, [
		tableParams.pagination.current,
		tableParams.pagination.pageSize,
		searchText,
	]);

	const debouncedSearch = useRef(debounce(handleSearch, 300)).current;

	useEffect(() => {
		return () => {
			debouncedSearch.cancel();
		}; //eslint-disable-next-line
	}, []);

const getStatusTag = (status) => {
	switch (status) {
		case "C":
			return <span className={styles.badgeCompleted}>Completed</span>;
		case "R":
			return <span className={styles.badgeRejected}>Rejected</span>;
		case "P":
			return <span className={styles.badgePending}>Pending</span>;
		default:
			return <span className={styles.badgeUnknown}>Unknown</span>;
	}
};

	// Define the columns for the AntD table
	const columns = [
  { title: 'Status', dataIndex: 'status', minWidth: 120, render: getStatusTag },

  { title: 'Date of Deactivation', dataIndex: 'deactivationDate', minWidth: 180, render: (v) => v && moment(v).format('DD-MMM-YYYY') },
  { title: 'ECCareSuite User ID', dataIndex: 'deactivateUserName', minWidth: 220 },

  { title: 'Full Name', dataIndex: 'fullName', minWidth: 240 },
  {
	title: 'Permitted Facilities',
	dataIndex: 'nhAdminFacilities',
	key: 'nhAdminFacilities',
	render: (value) => {
		const text = getFacilityNamesFromCodes(value, SSPFacilities?.data || []);
		if (!text) return '-';

		const items = text.split(',').map(s => s.trim()).filter(Boolean);

		return (
			<div>
				{items.map((item, idx) => (
					<div key={`${item}-${idx}`}>{item}</div>
				))}
			</div>
		);
	},minWidth: 240
},
{ title: 'Created By', dataIndex: 'createdBy', minWidth: 180 },
  { title: 'Created Date', dataIndex: 'createdDate', minWidth: 180, render: (v) => v && moment(v).format('DD-MMM-YYYY'), },

  { title: 'Requestor Designation', dataIndex: 'requestorDesignation', minWidth: 260 },
  {
		  title: 'NRIC / FIN',
		  dataIndex: 'nric',
		  minWidth: 200,
		  render: (value, record) => {
			if (!value) return '-';
		
			const isVisible = visibleNric[record.id];
		
			const masked = value.replace(/.(?=.{4})/g, '*');

			  return (
				  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
					  <span>{isVisible ? value : masked}</span>

					  {isVisible ? (
						  <EyeInvisibleOutlined
							  className={styles.nricEyeIcon}
							  onClick={() => toggleNric(record.id)}
						  />
					  ) : (
						  <EyeOutlined
							  className={styles.nricEyeIcon}
							  onClick={() => toggleNric(record.id)}
						  />
					  )}
				  </div>
			  );
		  },
		},

  { title: 'Email', dataIndex: 'email', minWidth: 320 },
  { title: 'Mobile Number', dataIndex: 'mobileNumber', minWidth: 200 },

  {
    title: "Supervisor / Manager's Name",
    dataIndex: 'supervisorName',
    minWidth: 260,
  },

  {
    title: 'Revoke Access to SSP Facility Code',
    dataIndex: 'sspAccessRevoke',
    minWidth: 300,
    render: (value) => {
    if (!value) return '-';

    const items = value.split(',').map(s => s.trim()).filter(Boolean);

    return (
        <div>
            {items.map((item, idx) => (
                <div key={idx}>{item}</div>
            ))}
        </div>
    );
	},
  },

  {
    title: 'Revoke Access to Clinical Facility',
    dataIndex: 'clinicalFacilityCodeDesc',
    minWidth: 320,
    render: (value) => {
    if (!value) return '-';

    const items = value.split(',').map(s => s.trim()).filter(Boolean);

    return (
        <div>
            {items.map((item, idx) => (
                <div key={idx}>{item}</div>
            ))}
        </div>
    );
	},
  },

  {
    title: 'Revoke Access to Finance Facility Code',
    dataIndex: 'financeFacilityCode',
    minWidth: 320,
    render: (value) => {
    if (!value) return '-';

    const items = value.split(',').map(s => s.trim()).filter(Boolean);

    return (
        <div>
            {items.map((item, idx) => (
                <div key={idx}>{item}</div>
            ))}
        </div>
    );
	},
  },

  {
    title: 'Revoke Access to HR Facility Code',
    dataIndex: 'hrFacilityCode',
    minWidth: 320,
    render: (value) => {
    if (!value) return '-';

    const items = value.split(',').map(s => s.trim()).filter(Boolean);

    return (
        <div>
            {items.map((item, idx) => (
                <div key={idx}>{item}</div>
            ))}
        </div>
    );
	},
  },

  { title: 'Remarks', dataIndex: 'remarks', minWidth: 320 },
  {
    title: 'Confirmation Email Recipient(s)',
    dataIndex: 'completionEmailList',
    minWidth: 360,
  },
  isAdmin && {
	  title: 'Approved By',
	  dataIndex: 'modifiedBy',
	  key: 'modifiedBy',
	  onHeaderCell: () => ({ style: { minWidth: 300 } }),
	  onCell: () => ({ style: { minWidth: 300 } }),
	},
	isAdmin && {
	  title: 'Approved Date',
	  dataIndex: 'modifiedDate',
	  key: 'modifiedDate',
	  onHeaderCell: () => ({ style: { minWidth: 300 } }),
	  onCell: () => ({ style: { minWidth: 300 } }),
	  render: (value) => value && moment(value).format('DD-MMM-YYYY'),
	},
].filter(Boolean);


	return (
		<div className={styles['wrapper']}>
			<div className={styles['top-section']}>
				<div className={styles['top-section-left']}>
					<div className={styles['left']}>
						<p className={styles['title']}>All Completed Deactivation</p>
						<div className={styles['totals']}>
							<img
								className={styles['success-icons']}
								src={SuccessIcon}
								alt="Success Icon"
							/>
							<p className={styles['totals']}>
								Total Insights : {tableParams.pagination.total}
							</p>
						</div>
					</div>
					<div className={styles['right']}>
						<Input
							prefix={<IoSearchOutline />}
							className={styles['search-input']}
							placeholder="Search by full name"
							onPressEnter={handleSearch}
							onChange={debouncedSearch}
							allowClear
						/>
					</div>
				</div>
			</div>

		{/* FIXED horizontal scroll */}
  <div className={styles.horizontalFixed}>
    <div className={styles.verticalScroll}>
      <Table
		className={styles.table}
		rowKey={(record) => record.id}
		dataSource={data}
		columns={columns}
		loading={loading}
		pagination={false}
		tableLayout="auto"
		onChange={handleTableChange}
		rowClassName={(_, index) =>
			index % 2 === 0 ? styles.evenRow : styles.oddRow
		}
		onRow={() => ({
			className: styles.rowWrapper,
		})}
		scroll={{
			x: 'max-content',  
			y: 450,
		}}
		/>

    </div>
  </div>

  {/* FIXED pagination */}
  <div className={styles.paginationWrapper}>
    <Pagination
      current={tableParams.pagination.current}
      pageSize={tableParams.pagination.pageSize}
      total={tableParams.pagination.total}
      showSizeChanger
      showQuickJumper
      hideOnSinglePage
      onChange={(page, pageSize) =>
        handleTableChange({ current: page, pageSize })
      }
    />
  </div>

</div>
		
	);
};

export default CompletedDeactivation;
